/*
  Sassy Shots — Juicy Bunch waitlist capture

  Sends to the same destination as the embedded Klaviyo form on
  /pages/juicy-signup: list Tm9k5K plus the profile property
  juicy_waitlist = "true", which is what segment Tadr5E reads.

  Endpoint, headers and content type were taken from the network call
  the live U3G5mQ embed makes when it is submitted, so this rides the
  same path Klaviyo's own form uses.

  Temporary drop-campaign component. Remove with the rest of the
  juicy-waitlist files when the drop goes public.
*/
(function () {
  'use strict';

  if (window.customElements && window.customElements.get('sassy-waitlist')) return;

  var ENDPOINT = 'https://a.klaviyo.com/client/subscriptions/';
  var REVISION = '2025-01-15';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  var SassyWaitlist = function () {
    return Reflect.construct(HTMLElement, [], SassyWaitlist);
  };

  SassyWaitlist.prototype = Object.create(HTMLElement.prototype);
  SassyWaitlist.prototype.constructor = SassyWaitlist;
  Object.setPrototypeOf(SassyWaitlist, HTMLElement);

  SassyWaitlist.prototype.connectedCallback = function () {
    if (this.bound) return;
    this.bound = true;

    this.form = this.querySelector('form');
    this.input = this.querySelector('[data-jw-email]');
    this.honeypot = this.querySelector('[data-jw-hp]');
    this.button = this.querySelector('[data-jw-submit]');
    this.formState = this.querySelector('[data-jw-form-state]');
    this.successState = this.querySelector('[data-jw-success-state]');
    this.errorNode = this.querySelector('[data-jw-error]');

    if (!this.form || !this.input) return;

    this.form.addEventListener('submit', this.onSubmit.bind(this));
  };

  SassyWaitlist.prototype.onSubmit = function (event) {
    event.preventDefault();
    if (this.busy) return;

    var email = (this.input.value || '').trim();

    if (!EMAIL_RE.test(email)) {
      this.showError(this.getAttribute('data-invalid-message') || 'That email does not look right.');
      this.input.focus();
      return;
    }

    // Bots fill every field they find; real people never see this one.
    if (this.honeypot && this.honeypot.value) {
      this.succeed();
      return;
    }

    this.showError('');
    this.setBusy(true);

    var self = this;
    var companyId = this.getAttribute('data-company-id');
    var listId = this.getAttribute('data-list-id');
    var property = this.getAttribute('data-property-name') || 'juicy_waitlist';
    var source = this.getAttribute('data-source') || 'site';

    var properties = {};
    properties[property] = 'true';
    properties[property + '_source'] = source;

    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: this.getAttribute('data-custom-source') || 'Juicy Bunch waitlist',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                properties: properties,
                subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
              }
            }
          }
        },
        relationships: {
          list: { data: { type: 'list', id: listId } }
        }
      }
    };

    fetch(ENDPOINT + '?company_id=' + encodeURIComponent(companyId), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: REVISION },
      body: JSON.stringify(payload)
    })
      .then(function (response) {
        if (response.status === 202 || response.ok) {
          self.succeed();
          return;
        }
        self.fail();
      })
      .catch(function () {
        self.fail();
      });
  };

  SassyWaitlist.prototype.setBusy = function (busy) {
    this.busy = busy;
    if (this.button) {
      this.button.disabled = busy;
      this.button.setAttribute('aria-busy', busy ? 'true' : 'false');
    }
  };

  SassyWaitlist.prototype.succeed = function () {
    this.setBusy(false);
    this.showError('');
    if (this.formState) this.formState.hidden = true;
    if (this.successState) {
      this.successState.hidden = false;
      this.successState.focus();
    }
  };

  SassyWaitlist.prototype.fail = function () {
    this.setBusy(false);
    this.showError(this.getAttribute('data-error-message') || 'That did not go through. Try again?');
  };

  SassyWaitlist.prototype.showError = function (message) {
    if (this.errorNode) this.errorNode.textContent = message;
  };

  window.customElements.define('sassy-waitlist', SassyWaitlist);
})();
